import { default as MuiCardActions } from '@material-ui/core/CardActions';

const CardActions = MuiCardActions;

export default CardActions;
